<template>
    <div class="send-rule-add-main">
        <div class="send-rule-left" @mouseenter="outlineMouseEnter()">
            <time-line :active-id="selectedId" @change="onBookmarkClick" :time-line-arr="timeLineArr" ></time-line>
        </div>
        <div class="send-rule-right">
            <div ref="scrollRect" v-record-scroll @mouseenter="contentMouseEnter()" @scroll="throttleScroll" class="send-rule-add">
                <el-form ref="form" :model="form" label-width="100px">
                    <gj-area-title id="baseinfo">基础信息</gj-area-title>
                    <el-row style="width: 1088px;">
                        <el-col :span="8">
                            <el-form-item label="关怀邮件类型" prop="mailType"
                                :rules="[{ required: true, message: '请选择关怀邮件类型', trigger: 'change' }]">
                                <gj-select
                                    v-model="form.mailType"
                                    @change="mailTypeChange"
                                    :disabled="$route.params.state === 'view'"
                                    :clearable="false"
                                    style="width: 100%;"
                                    :options="templateTypeOptions">
                                </gj-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <gj-country-server-select
                                v-model="form.countryMarketValue"
                                is-active
                                :disabled="$route.params.state === 'view'"
                                @change="countryMarketChange"
                                :isFormColumn="true"
                                :width="['100%', '100%']">
                            </gj-country-server-select>
                        </el-col>
                    </el-row>
                    <el-form-item label="规则名称" prop="name"
                        :rules="[{ required: true, message: '请输入规则名称', trigger: ['input', 'blur'] }]">
                        <gj-input v-model="form.name" :disabled="$route.params.state === 'view'" @blur="nameBlur" style="width: 988px;"
                            placeholder="请输入规则名称">
                        </gj-input>
                    </el-form-item>
                    <el-form-item label="发送内容" prop="useCustomerTemplate"
                        v-if="form.mailType !== 'AMAZON_REQUEST_REVIEW'"
                        :rules="[{ required: true, message: '请输入发送内容', trigger: 'change' }]" class="send-content">
                        <el-radio-group v-model="form.useCustomerTemplate" :disabled="$route.params.state === 'view'">
                            <el-radio :label="0">使用模板</el-radio>
                            <el-radio :label="1">自定义</el-radio>
                        </el-radio-group>
                        <el-row style="width: 988px;" class="gj-mt10" v-show="form.useCustomerTemplate == 0">
                            <el-col :span="6">
                                <gj-cascader-select
                                    :disabled="$route.params.state === 'view'"
                                    :isInit="$route.params.state === 'add' && !$route.query.id"
                                    ref="gjCascaderSelect"
                                    class="gj-cascader-select"
                                    height="358px"
                                    @templateRow="templateRowHandler"
                                    :content-type="form.useCustomerTemplate"
                                    :country-list="form.countryMarketValue.countryIds || []"
                                    :market-id-list="form.countryMarketValue.marketIds || []">
                                </gj-cascader-select>
                            </el-col>
                            <el-col :span="18">
                                <div class="temlpate-mail-content">
                                    <div class="content-header">
                                        <div class="content-header-left">
                                            <span style="color:#999999;">邮件主题</span>
                                            {{ form.templateInfo.subject }}
                                        </div>
                                        <div class="content-header-right" v-if="$route.params.state !== 'view'" @click="copyTemlpate">
                                            复制并去自定义
                                        </div>
                                    </div>
                                    <div class="content-text">
                                        <span v-html="form.templateInfo.content"></span>
                                    </div>
                                </div>

                            </el-col>
                        </el-row>
                        <el-row style="width: 988px;" v-if="form.useCustomerTemplate == 0">
                            <el-col :span="8">
                                <span class="tips" @click="guideHandler" style="margin: 0px 44px 0px 0px;">
                                    亚马逊沟通指南
                                </span>
                                <span class="tips" @click="allowHandler">
                                    亚马逊允许的HTML
                                </span>
                            </el-col>
                            <el-col :span="16">
                                <span @click="queryExplain" class="tips" style="float: right;cursor: pointer;">
                                    查看使用说明 >
                                </span>
                            </el-col>
                        </el-row>
                        <div style="width: 988px;" class="gj-mt10" v-if="form.useCustomerTemplate == 1">
                            <el-form-item prop="customInfo.subject">
                                <gj-input
                                    v-model="form.customInfo.subject"
                                    placeholder="请输入邮件主题"
                                    :disabled="$route.params.state === 'view'"
                                    width="100%">
                                    <template slot="prepend">邮件主题</template>
                                </gj-input>
                            </el-form-item>
                            <el-row class="gj-mt16">
                                <el-col :span="18">
                                    <div>
                                        <gj-wang-editor
                                            ref="gjWangEditor"
                                            v-model="form.customInfo.content"
                                            :maxLength="4000"
                                            :readOnly="$route.params.state === 'view'"
                                            height="316">
                                        </gj-wang-editor>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <gj-variable-select
                                        class="gj-cascader-select"
                                        :is-search="false"
                                        height="381px"
                                        :disabled="$route.params.state === 'view'"
                                        @templateRow="templateRowHandler"
                                        :content-type="form.useCustomerTemplate">
                                    </gj-variable-select>
                                </el-col>
                            </el-row>
                        </div>
                    </el-form-item>
                    <template v-if="form.mailType !== 'HOLIDAYS_AUTO_REPLY'">
                        <gj-area-title id="selectgoods">选择商品</gj-area-title>
                        <el-form-item  label="商品范围" prop="requestListingType"
                            :rules="[{ required: true, message: '请选择商品范围', trigger: 'change' }]">
                            <el-radio-group v-model="form.requestListingType" :disabled="$route.params.state === 'view'">
                                <el-radio label="AllListing">全部商品</el-radio>
                                <el-radio label="SpecificListing">部分商品</el-radio>
                                <el-radio label="ExcludeListing">排除部分商品</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <div v-if="form.requestListingType !== 'AllListing'" v-loading="goodsLoading" style="margin-left:35px;width: 1053px;">
                            <gj-button @click="addGoods(true)" v-if="$route.params.state !== 'view'">选择商品</gj-button>
                            <gj-button @click="addGoods(false)" v-if="$route.params.state !== 'view'">输入ASIN</gj-button>
                            <template v-if="goodsTableData.length > 0">
                                <gj-table
                                    ref="gjTable"
                                    :data="goodsTableData"
                                    :adapt-height="false"
                                    :index="false"
                                    :isMinHeight="false"
                                    :isMaxHeight="true"
                                    :maxHeight="400"
                                    :columns="columns"
                                    style="margin-top:15px;">
                                    <template v-slot:status="{ row }">
                                        <gj-tag type="text" :color="getColor(row.status)">{{ row.status | optionText(listingStatustwo) }}</gj-tag>
                                    </template>
                                    <template v-slot:op="{ index }">
                                        <gj-button type="text" @click="deleteRow(index)" :disabled="$route.params.state === 'view'">移除</gj-button>
                                    </template>
                                </gj-table>
                            </template>
                        </div>
                    </template>
                    <gj-area-title id="setrule" style="margin-top:25px;">设置规则</gj-area-title>
                    <template v-if="form.mailType == 'HOLIDAYS_AUTO_REPLY'">
                        <el-form-item label="发送规则" prop="sendConditionHolidayUserInterval">
                            所有买家消息
                        </el-form-item>
                        <el-form-item class="is-required">
                            <template #label>设置时间
                                <gj-tooltip class="item" effect="dark" content="时区为北京时间">
                                    <i class="el-icon-question fontsize12 colorD8DADD"></i>
                                </gj-tooltip>
                            </template>
                            <div class="flex justify-start tip-box" style="width: 1088px;">
                                <div v-for="(item, index) in setTime" :key="index"
                                    style="margin-bottom: 10px; margin-right: 38px;">
                                    <gj-date-picker
                                        v-model="item.date"
                                        type="daterange"
                                        :disabled="$route.params.state === 'view'"
                                        width="220px"
                                        :disabledDate="disabledDate"
                                        style="margin-right: 20px;"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                    </gj-date-picker>
                                    <template v-if="$route.params.state !== 'view'">
                                        <i class="el-icon-circle-plus-outline" @click="addDate"></i>
                                        <i class="el-icon-remove-outline" @click="deleteDateRow(index)"
                                            v-if="setTime.length > 1 && index >= 0"></i>
                                    </template>
                                </div>
                            </div>
                        </el-form-item>
                    </template>
                    <template v-else>
                        <el-form-item label="发送规则" prop="orderTypeSelect"
                            :rules="[{ required: true, message: '请选择发送规则', trigger: 'change' }]">
                            <el-radio-group v-model="form.orderTypeSelect" :disabled="$route.params.state === 'view'">
                                <el-radio label="ALL">所有订单</el-radio>
                                <el-radio label="PART">部分订单</el-radio>
                            </el-radio-group>
                            <div class="send-rule-list" v-if="form.orderTypeSelect == 'PART'">
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item label="订单类型" label-width="70px" prop="orderTypeList"
                                            :rules="[{ required: true, message: '请选择订单类型', trigger: 'change' }]">
                                            <gj-select v-model="form.orderTypeList" :disabled="$route.params.state === 'view'"
                                                :options="orderTypeListOptions" :isShowAllChecked="false" type="multi-check" style="width: 170px;">
                                            </gj-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="订单配送渠道" label-width="100px" prop="orderFulfillmentChannel"
                                            :rules="[{ required: true, message: '请选择订单类型', trigger: 'change' }]">
                                            <gj-select
                                                v-model="form.orderFulfillmentChannel"
                                                :disabled="$route.params.state === 'view'"
                                                :options="orderFulfillmentChannelOptions"
                                                style="width: 220px;">
                                            </gj-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="过滤订单" label-width="70px" prop="filterOrder"
                                    :rules="[{ required: true, message: '请选择过滤订单', trigger: 'change' }]">
                                    <gj-select v-model="form.filterOrder" :options="filterOrderOptions"
                                        :disabled="$route.params.state === 'view'" style="width: 170px;">
                                    </gj-select>
                                </el-form-item>
                                <el-form-item label="订单金额" label-width="70px" prop="orderAmountSelect"
                                    :rules="[{ required: true, message: '请选择订单金额', trigger: 'change' }]">
                                    <el-radio-group v-model="form.orderAmountSelect" :disabled="$route.params.state === 'view'">
                                        <el-radio label="ALL">不限制</el-radio>
                                        <el-radio label="INTERVAL">指定区间</el-radio>
                                    </el-radio-group>
                                    <div v-if="form.orderAmountSelect == 'INTERVAL'" class="gj-mt5 flex">
                                        <span class="currency" v-if="currency">{{currency}}</span>
                                        <el-input-number
                                            v-model.number="form.orderAmountIntervalMin"
                                            controls-position="right"
                                            size="small"
                                            :min="0"
                                            :precision="2"
                                            placeholder="请输入"
                                            :max="form.orderAmountIntervalMax || 100000"
                                            style="width: 148px;"
                                            :style="currency ? {
                                                width: '110px',
                                                borderTopLeftRadius: 0,
                                                borderBottomLeftRadius: 0,
                                            }:''"
                                            :disabled="$route.params.state === 'view'">
                                        </el-input-number>
                                        <span class="gj-plr12">-</span>
                                        <span class="currency" v-if="currency">{{currency}}</span>
                                        <el-input-number
                                            v-model.number="form.orderAmountIntervalMax"
                                            controls-position="right"
                                            size="small"
                                            :min="form.orderAmountIntervalMin"
                                            :precision="2"
                                            placeholder="请输入"
                                            style="width: 148px;"
                                            :style="currency ? {
                                                width: '110px',
                                                borderTopLeftRadius: 0,
                                                borderBottomLeftRadius: 0,
                                            }:''"
                                            :disabled="$route.params.state === 'view'">
                                        </el-input-number>
                                    </div>
                                </el-form-item>
                            </div>
                        </el-form-item>
                        <el-form-item label="过滤规则" prop="filterSelect"
                            :rules="[{ required: true, message: '请选择过滤规则', trigger: 'change' }]">
                            <el-radio-group v-model="form.filterSelect" :disabled="$route.params.state === 'view'">
                                <el-radio label="ALL">不过滤</el-radio>
                                <el-radio label="PART">制定过滤条件</el-radio>
                            </el-radio-group>
                            <div class="send-rule-list" v-if="form.filterSelect == 'PART'">
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item
                                            label="过滤频次"
                                            label-width="70px"
                                            prop="filterSendInterval"
                                            :rules="[{ required: true, message: '请选择过滤频次', trigger: 'change' }]">
                                            <gj-select v-model="form.filterSendInterval" :options="filterSendIntervalOptions"
                                                :disabled="$route.params.state === 'view'" style="width: 100px;">
                                            </gj-select>
                                            天内同一买家只发送一次
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="过滤用户" label-width="70px">
                                    <filtering-rules :filterUserList="form.filterUserList" :disabled="$route.params.state === 'view'" ref="filteringRules">
                                    </filtering-rules>
                                </el-form-item>
                            </div>
                        </el-form-item>
                    </template>
                    <gj-area-title id="setsend" style="margin-top:25px">设置发送条件</gj-area-title>
                    <div style="width: 765px;" v-if="form.mailType !== 'HOLIDAYS_AUTO_REPLY'">
                        <el-form-item label="发送时间" prop="sendConditionFbaOrderDay" class="is-required">
                            <div class="flex justify-between">
                                <div v-if="form.orderTypeSelect == 'ALL' || (form.orderTypeSelect == 'PART' && form.orderFulfillmentChannel != 'FBM')">
                                    FBA订单
                                    <gj-select
                                        v-model="form.sendConditionFbaOrderType"
                                        :disabled="$route.params.state === 'view'"
                                        :clearable="false"
                                        :options="sendConditionFbaOrderTypeOptions"
                                        width="120px"
                                        style="margin-left: 10px;">
                                    </gj-select>
                                    <el-input-number
                                        v-model="form.sendConditionFbaOrderDay"
                                        :clearable="false" :step-strictly="true" :min="1" size="small"
                                        :disabled="$route.params.state === 'view'" controls-position="right" style="margin-left: 10px;width: 120px;">
                                    </el-input-number>
                                    天
                                </div>
                                <div v-if="form.orderTypeSelect == 'ALL' || (form.orderTypeSelect == 'PART' && form.orderFulfillmentChannel != 'FBA')">
                                    FBM订单—订单订购后
                                    <el-input-number
                                        v-model="form.sendConditionFbmOrderDay"
                                        :clearable="false" :step-strictly="true" :min="1" size="small"
                                        :disabled="$route.params.state === 'view'" controls-position="right" style="margin-left: 10px;width: 80px;">
                                    </el-input-number>
                                    天
                                </div>
                            </div>
                            <div class="gj-mt10" v-if="form.mailType !== 'HOLIDAYS_AUTO_REPLY'">
                                站点时间
                                <gj-select
                                    v-model="form.sendConditionLocalTimeMin"
                                    :options="sendConditionLocalTimeOptions"
                                    :disabled="$route.params.state === 'view'"
                                    :clearable="false"
                                    style="width: 120px;margin-left: 10px;">
                                </gj-select>
                            </div>
                        </el-form-item>
                    </div>
                    <el-form-item label="规则状态" prop="status">
                        <el-radio-group v-model="form.status" :disabled="$route.params.state === 'view'">
                            <el-radio label="Active">开启</el-radio>
                            <el-radio label="Inactive">关闭</el-radio>
                        </el-radio-group>
                        <div class="gj-mt10" v-if="form.status == 'Active' && form.mailType !== 'HOLIDAYS_AUTO_REPLY'">
                            <span class="color666">历史订单</span>
                            <el-radio-group style="margin-left: 10px;" v-model="form.historicalOrder" @change="historicalOrderChange" :disabled="$route.params.state === 'view'">
                                <el-radio :label="1">
                                    发送
                                    <el-input-number
                                        v-model="form.sendConditionOldOrderRequestDay"
                                        :min="0"
                                        :max="30"
                                        size="small"
                                        :disabled="$route.params.state === 'view'"
                                        controls-position="right"
                                        :step-strictly="true"
                                        style="margin-left: 25px;width: 100px;">
                                    </el-input-number>
                                    <span style="margin-left: 10px;color:#666;">天内已发货订单</span>
                                </el-radio>
                                <el-radio :label="2">不发送</el-radio>
                            </el-radio-group>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="send-rule-right-divider">
                <el-divider class="divider-b"></el-divider>
                <gj-button @click="close" v-if="$route.params.state === 'view'">关闭</gj-button>
                <gj-button @click="cancel" v-if="$route.params.state !== 'view'">取消</gj-button>
                <gj-button type="primary" :loading="previewLoading" plain @click="preview" v-show="form.mailType !== 'HOLIDAYS_AUTO_REPLY'"
                    v-if="$route.params.state === 'add' || $route.params.state === 'edit'">预览
                </gj-button>
                <gj-button type="primary" @click="save" v-if="$route.params.state !== 'view'" :loading="loading">保存
                </gj-button>
            </div>
        </div>
    </div>
</template>

<script>
import SendRulePreview from './modal/send-rule-preview.vue';
import SendRulePreviewOther from './modal/send-rule-preview-other.vue';
import TimeLine from './components/time-line.vue';
import FilteringRules from './components/filtering-rules.vue';
import GoodsTable from './modal/goods-table.vue';
import InstructionsTable from './modal/instructions-table.vue';
import GjWangEditor from '@/components/wang-editor/gj-wang-editor';
import GjCascaderSelect from './components/cascader-select';
import GjVariableSelect from './components/variable-select';
import { currencyMarketOption, listingStatustwo } from '@/utils/options'
import { isMeaningfulMixin, keepAliveMixin} from "@/minxins";
import { templateTypeOptions, orderTypeListOptions, orderFulfillmentChannelOptions, sendConditionLocalTimeOptions, sendConditionFbaOrderTypeOptions, filterSendIntervalOptions, filterOrderOptions } from './viewConfig'
import { mapGetters } from "vuex";
import { defaultVal, isMeaningful, transformToMap, isMeaningless } from "@/utils/common";
import { validateSameName, requestRuleAdd, listOrderListView, requestRuleDetal, updateSendRule, simpleListings, countNotExecuteRecord } from "@/api/crm";
import { convertToDate } from '@/utils/date.util'
import { tagColors } from '@/components/tag/tag-colors';
import { throttle } from 'lodash'
export default {
    name: "send-rule-view",
    mixins: [isMeaningfulMixin, keepAliveMixin],
    components: {
        TimeLine,
        GjWangEditor,
        GjCascaderSelect,
        GjVariableSelect,
        FilteringRules
    },
    computed: {
        ...mapGetters({
            markets: 'authMarkets',
            navMenuTabs: 'navMenuTabs',
            marketOption: 'marketOption'
        }),
        currency () {
            let currency = ''
            if(this.form.countryMarketValue.countryIds.length === 1) {
                let countryCode = this.form.countryMarketValue.countryIds[0]
                if(isMeaningful(countryCode)) {
                    currency = currencyMarketOption.find(item => item.text === countryCode)?.currency || ''
                }
            } else if(this.form.countryMarketValue.marketIds.length > 0){
                let countryCodeArr = []
                this.form.countryMarketValue.marketIds.forEach(item => {
                    let countryCode = this.markets.find(market => market.id === item)?.countryCode || ''
                    countryCodeArr.push(countryCode)
                })
                let countryCode = countryCodeArr[0]
                let flag = true
                countryCodeArr.forEach(item => {
                    if(countryCode !== item) {
                        flag = false
                    }
                })
                if(flag) {
                    currency = currencyMarketOption.find(item => item.text === countryCode)?.currency || ''
                }
            }
            return currency
        },
    },
    created() {
        if(this.$route.params.state !== 'add' || isMeaningful(this.$route.query.id)) {
            let id = this.$route.params.id || this.$route.query.id;
            this.id = id;
            this.queryDetail(id);
        }
    },
    mounted() {
        let id = this.$route.params.id || this.$route.query.id;
        this.id = id;
        this.scrollRect = this.$refs.scrollRect.getBoundingClientRect();
    },
    activated() {
        if(this.$route.params.state !== 'add' || isMeaningful(this.$route.query.id)) {
            let id = this.$route.params.id || this.$route.query.id
            if (this.id !== id) {
                this.id = id
                this.queryDetail(id)
            }
        }
        this.scrollRect = this.$refs.scrollRect.getBoundingClientRect();
    },
    data() {
        return {
            templateTypeOptions,
            orderTypeListOptions,
            orderFulfillmentChannelOptions,
            filterSendIntervalOptions,
            filterOrderOptions,
            sendConditionFbaOrderTypeOptions,
            sendConditionLocalTimeOptions,
            listingStatustwo,
            form: {
                mailType: 'AMAZON_REQUEST_REVIEW',//关怀类型
                countryMarketValue: {
                    countryIds: [],
                    marketIds: []
                },
                name: "",//规则名称
                orderTypeList: [],//订单类型
                useCustomerTemplate: 0,//0：使用模板，1：使用自定义模板
                filterOrder: "ALL",//过滤订单 ALL:不排除, HAS_REQUEST_REVIEW:已请求评论的订单
                requestListingType: "AllListing", //AllListing("所有商品订单"),SpecificListing("针对购买指定商品订单"),ExcludeListing("排除购买指定商品订单");
                requestListingList: [],//选择商品ASIN集合
                requestListingIdList: [], // 选择商品id集合
                orderTypeSelect: "ALL",//ALL：所有，PART：部分
                filterSelect: "ALL",//枚举： ALL：所有，PART：部分
                status: "Active",//枚举： Inactive：暂停（关闭），Active：启用，Close：归档
                orderAmountSelect: "ALL",// ALL:不限制，INTERVAL：指定区间
                orderFulfillmentChannel: "",//订单配送渠道 ALL：不区分渠道， FBA：FBA，FBM：FBM
                orderAmountIntervalMin: "",//订单金额指定区间下限
                orderAmountIntervalMax: "",//订单金额指定区间上限
                filterSendInterval: "7",//过滤频次
                filterUserList: [
                    {
                        type: '',//过滤用户条件类型
                        value: ''//过滤用户条件时间（天）
                    }
                ],
                sendConditionFbaOrderType: "Purchase",//发送条件发送FBA订单类型	 Purchase("订单订购后"), Shipped("订单发货后"),Delivery("订单送达后");
                sendConditionFbaOrderDay: 1,//发送条件发送FBA订单时间（天）
                sendConditionFbmOrderDay: 1,//发送条件发送FBM订单时间（天）
                sendConditionLocalTimeMax: "",//发送条件定时发送的站点时间上限（小时）
                sendConditionLocalTimeMin: 0,//发送条件定时发送的站点时间下限（小时）
                templateInfo: { // 邮件模板内容
                    content: "",//邮件内容
                    name: "",//邮件名称
                    ruleId: null,
                    subject: "",//邮件主题
                    textType: "RichText", //邮件内容类型(富文本:RichText,纯文本:PureText)
                },
                customInfo: { // 自定义邮件内容
                    content: "",//邮件内容
                    name: "",
                    ruleId: null,
                    subject: "",//邮件主题
                    textType: "RichText", //邮件内容类型(富文本:RichText,纯文本:PureText)
                },
                historicalOrder: 2,//历史订单
                sendConditionOldOrderRequestDay: 0,//发送条件历史订单（天）
            },
            oldForm: null,
            filterUserList: [
                {
                    type: '',//过滤用户条件类型
                    value: ''//过滤用户条件时间（天）
                }
            ],
            setTime: [
                {
                    date: []
                }
            ],
            disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7; // 限制今天之前
            },
            columns: [
                { id: 'picture', header: '图片', field: 'picture:imageUrl', minWidth: '150px', default: true },
                { id: 'asin', header: 'ASIN', field: 'asin', minWidth: '150px', default: true },
                { id: 'sku', header: 'SKU', field: 'sku', minWidth: '150px', default: true },
                { id: 'marketId', header: '店铺/站点', field: 'option:marketId', minWidth: '150px', options: () => this.marketOption, },
                { id: 'status', header: '状态', field: 'slot:status', minWidth: '150px' },
                { id: 'op', header: '操作', field: 'slot:op', width: '80px', fixed: 'right' }
            ],
            goodsTableData: [],
            isPreview: false,
            loading: false,
            goodsLoading: false,
            previewLoading: false,
            // 滚动进度效果
            selectedId: 'baseinfo',
            scrollRect: null,
            timeLineArr: [
                { id: 'baseinfo',  content: "基础信息" },
                { id: 'selectgoods', content: "选择商品" },
                { id: 'setrule', content: "设置规则" },
                { id: 'setsend', content: "设置发送条件", noImg: true }
            ],
            enableListenScroll: false,
            throttleScroll: throttle(this.contentScroll, 50)
        }
    },
    methods: {
        queryDetail(id) {
            this.loading = true
            requestRuleDetal(id).then(res => {
                let templateInfo = {
                    content: "",//邮件内容
                    ruleId: "",//邮件id
                    name: "",//邮件名称
                    subject: "",//邮件主题
                    textType: "RichText",//邮件内容类型(富文本:RichText,纯文本:PureText)
                }
                let filterUserList = res.filterUserList || []
                if(res.filterUserList.length === 0) {
                    filterUserList = this.filterUserList
                }
                this.form = {
                    mailType: res.mailType,
                    name: res.name,
                    countryMarketValue: {
                        countryIds: res.countryList || [],
                        marketIds: res.marketIdList || [],
                    },
                    useCustomerTemplate: res.mailType !== 'AMAZON_REQUEST_REVIEW' ? res.useCustomerTemplate : 1,
                    templateInfo: res.useCustomerTemplate === 0  && isMeaningful(res.templateInfo) ? res.templateInfo : templateInfo,
                    customInfo: res.useCustomerTemplate === 1 && isMeaningful(res.templateInfo) ? res.templateInfo : templateInfo,
                    requestListingType: res.requestListingType || 'AllListing',
                    requestListingList: res.requestListingList || [],
                    requestListingIdList: res.listingIds || [],
                    orderTypeSelect: res.orderTypeSelect || 'ALL',
                    orderTypeList: res.orderTypeList|| [],
                    orderFulfillmentChannel: res.orderFulfillmentChannel || 'ALL',
                    orderAmountSelect: res.orderAmountSelect || 'ALL',
                    orderAmountIntervalMin: res.orderAmountSelect === 'ALL' ? '' : res.orderAmountIntervalMin,
                    orderAmountIntervalMax: res.orderAmountSelect === 'ALL' ? '' : res.orderAmountIntervalMax,
                    filterSelect: res.filterSelect || 'ALL',
                    filterSendInterval: res.filterSendInterval || "7",
                    filterOrder: res.filterOrder || 'ALL',
                    filterUserList: filterUserList,
                    sendConditionFbaOrderType: res.sendConditionFbaOrderType || 'Purchase',
                    sendConditionFbaOrderDay: res.sendConditionFbaOrderDay,
                    sendConditionFbmOrderDay: res.sendConditionFbmOrderDay,
                    sendConditionLocalTimeMin: res.sendConditionLocalTimeMin || 0,
                    status: res.status || 'Inactive',
                    historicalOrder: res.sendConditionOldOrderRequestDay !== 0 ? 1 : 2,
                    sendConditionOldOrderRequestDay: res.sendConditionOldOrderRequestDay
                };
                this.oldForm = this._.cloneDeep(this.form)
                this.mailTypeChange(this.form.mailType)
                if(res.mailType === 'HOLIDAYS_AUTO_REPLY') {
                    this.setTime = []
                    res.sendConditionHolidayDate.forEach(item => {
                        this.setTime.push({
                            date: [item.startDate, item.endDate]
                        })
                    })
                }
                if(this.form.requestListingIdList.length > 0 || this.form.requestListingList.length > 0) {
                    let ids = this.form.requestListingIdList
                    let asinArr = this.form.requestListingList.map(item => item.asin)
                    let size = ids.length > asinArr.length ? ids.length : asinArr.length
                    this.goodsInit(ids, asinArr, size)
                }
                if (this.$route.params.state === 'add') {
                    this.form.name = ""
                    this.form.id = ""
                }
            }).complete(() => {
                this.loading = false;
            });
        },
        // 获取商品信息
        goodsInit(ids, asinArr, size){
            let params = {
                size: size,
                current: 1,
                model: {
                    listingIds: ids,
                    asinList: asinArr
                }
            }
            this.goodsLoading = true
            simpleListings(params)
                .then((data) => {
                    if (isMeaningful(data)) {
                        this.goodsTableData = data.records;
                    }
                })
                .complete(() => {
                    this.goodsLoading = false;
                });
        },
        mailTypeChange(ev) {
            if(ev === 'HOLIDAYS_AUTO_REPLY') {
                this.selectedId = 'baseinfo';
                this.timeLineArr = [
                    { id: 'baseinfo',  content: "基础信息" },
                    { id: 'setrule', content: "设置规则" },
                    { id: 'setsend', content: "设置发送条件", noImg: true }
                ];
            } else {
                this.selectedId = 'baseinfo';
                this.timeLineArr = [
                    { id: 'baseinfo',  content: "基础信息" },
                    { id: 'selectgoods', content: "选择商品" },
                    { id: 'setrule', content: "设置规则" },
                    { id: 'setsend', content: "设置发送条件", noImg: true }
                ];
            }
        },
        nameBlur() {
            if (this.form.name) {
                let params = {
                    name: this.form.name,
                    id: this.$route.params.id || ''
                }
                validateSameName(params).then(data => {
                    // true, 名称已存在, false, 名称不存在
                    if (data) {
                        this.form.name = '';
                        this.$gjMessage.warning("规则名称重复！")
                    }
                })
            }
        },
        deleteRow(index) {
            this.goodsTableData.splice(index, 1);
        },
        addDate() {
            this.setTime.push({
                date: []
            })
        },
        deleteDateRow(index) {
            this.setTime.splice(index, 1);
        },
        addGoods(value) {
            const modal = this.$gjCreate(GoodsTable, {
                props: {
                    title: value ? '选择商品' : '输入ASIN',
                    isGoods: value,
                    hideIds: this.goodsTableData.map(item => item.id),
                    countryMarketValue: this._.cloneDeep(this.form.countryMarketValue)
                },
                on: {
                    confirmSelect: (value) => {
                        this.goodsTableData = [...this.goodsTableData, ...value]
                    },
                    cancel: () => modal.$gjDestroy(),
                },
            })
        },
        getColor(status) {
            switch (status) {
            case 'Active':
                return tagColors.greenText;
            case 'Inactive':
                return tagColors.gray9Text;
            case 'Incomplete':
                return tagColors.orangeText;
            case 'Delete':
                return tagColors.gray6Text;
            }
        },
        queryExplain() {
            const modal = this.$gjCreate(InstructionsTable, {
                on: {
                    confirm: () => {
                        modal.$gjDestroy();
                    }
                }
            })
        },
        guideHandler() {
            window.open('https://sellercentral.amazon.com/gp/help/external/G1701?language=zh_CN&ref=efph_G1701_cont_521', '_blank');
        },
        allowHandler() {
            window.open('https://sellercentral.amazon.com/gp/help/external/200415980?language=zh_CN', '_blank');
        },
        templateRowHandler(row) {
            if (this.form.useCustomerTemplate == 0) {
                this.form.templateInfo.content = row.content;
                this.form.templateInfo.subject = row.emailSubject;
                this.form.templateInfo.name = row.name;
                this.form.templateInfo.ruleId = row.id;
                this.form.templateInfo.textType = "PureText";//邮件内容类型(富文本:RichText,纯文本:PureText)
                this.form.useTemplateId = row.id;
            } else {
                this.$refs.gjWangEditor.insertVariable(row.variableValue);
                this.form.useTemplateId = "";
            }
        },
        copyTemlpate() {
            if (!this.form.templateInfo.ruleId) {
                this.$gjMessage.warning("请先选择模板！");
                return false
            }
            Object.assign(this.form.customInfo, this.form.templateInfo)
            this.form.useCustomerTemplate = 1;
        },
        historicalOrderChange(value) {
            if (value == 1 && this.form.sendConditionOldOrderRequestDay == 0) {
                this.form.sendConditionOldOrderRequestDay = 7;
            } else {
                this.form.sendConditionOldOrderRequestDay = 0;
            }
        },
        countryMarketChange(value) {
            if(this.$refs.gjCascaderSelect) {
                this.$refs.gjCascaderSelect.templateListQuery()
            }
        },
        //提交数据处理
        submitForm(type, callBack) {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let formDate = this.form
                    // request a review关怀邮件, 不需要选择发送内容
                    if(formDate.mailType !== 'AMAZON_REQUEST_REVIEW' && formDate.useCustomerTemplate === 0 && isMeaningless(formDate.templateInfo.content)) {
                        this.$gjMessage.error("请选择邮件模板！")
                        return false
                    }
                    if(formDate.mailType !== 'AMAZON_REQUEST_REVIEW' && formDate.useCustomerTemplate === 1 && isMeaningless(formDate.customInfo.subject)) {
                        this.$gjMessage.error("请输入发送邮件主题！")
                        return false
                    }
                    if(formDate.mailType !== 'AMAZON_REQUEST_REVIEW' && formDate.useCustomerTemplate === 1 && isMeaningless(formDate.customInfo.content)) {
                        this.$gjMessage.error("请输入发送内容！")
                        return false
                    }
                    // 节假日自动回复类型的关怀邮件, 不需要选择商品
                    if(formDate.mailType !== 'HOLIDAYS_AUTO_REPLY' && formDate.requestListingType !== 'AllListing' && this.goodsTableData.length == 0) {
                        this.$gjMessage.error("请选择商品！")
                        return false
                    } else if(formDate.mailType !== 'HOLIDAYS_AUTO_REPLY' && formDate.requestListingType !== 'AllListing' && this.goodsTableData.length > 0) {
                        // 校验选择商品是否属于规则使用国家站点
                        const countryList = formDate.countryMarketValue.countryIds || []
                        const marketIdList = formDate.countryMarketValue.marketIds || []
                        let filterGoods = []
                        if(marketIdList.length > 0 && countryList.length > 0) {
                            filterGoods = this.goodsTableData.filter(item => !marketIdList.includes(item.marketId) && !marketIdList.includes(item.countryCode))
                            if(filterGoods.length > 0) {
                                this.$gjMessage.error("请移除不属于该国家店铺下的商品！")
                                return false
                            }
                        } else if(marketIdList.length > 0) {
                            filterGoods = this.goodsTableData.filter(item => !marketIdList.includes(item.marketId))
                            if(filterGoods.length > 0) {
                                this.$gjMessage.error("请移除不属于该国家店铺下的商品！")
                                return false
                            }
                        } else if(countryList.length > 0) {
                            filterGoods = this.goodsTableData.filter(item => !countryList.includes(item.countryCode))
                            if(filterGoods.length > 0) {
                                this.$gjMessage.error("请移除不属于该国家店铺下的商品！")
                                return false
                            }
                        }
                    }
                    // 节假日自动回复类型的关怀邮件, 设置规则发送时间
                    if(formDate.mailType === 'HOLIDAYS_AUTO_REPLY' && this.setTime.length > 0) {
                        let flag
                        this.setTime.forEach(item => {
                            if(item.date && item.date.length == 0) {
                                flag = true
                            }
                        })
                        if(flag) {
                            this.$gjMessage.error("请完善发送规则中的时间设置！")
                            return false
                        }
                    }else if(formDate.mailType !== 'HOLIDAYS_AUTO_REPLY') { // 其他类型的关怀邮件, 规则校验
                        if(formDate.orderAmountSelect === 'INTERVAL') {
                            if(isMeaningless(formDate.orderAmountIntervalMin) || isMeaningless(formDate.orderAmountIntervalMax)) {
                                this.$gjMessage.error("请指定订单金额的区间！")
                                return false
                            }
                        }
                        if(formDate.filterSelect === 'PART') {
                            let filterUserList = this.$refs.filteringRules.backFilteringTable()
                            for(let i = filterUserList.length - 1; i >= 0; i--)  {
                                let item = filterUserList[i]
                                if(isMeaningless(item.type) || isMeaningless(item.value)) {
                                    filterUserList.splice(i, 1)
                                }
                            }
                            if(filterUserList.length == 0) {
                                this.filterUserList = null
                            } else {
                                this.filterUserList = filterUserList
                            }
                        }
                    }
                    // 设置发送条件--发送时间, 根据对应的订单配送渠道校验
                    if(formDate.mailType !== 'HOLIDAYS_AUTO_REPLY' && formDate.orderTypeSelect === 'PART') {
                        if(formDate.orderFulfillmentChannel === 'All') {
                            if(isMeaningless(formDate.sendConditionFbaOrderDay)) {
                                this.$gjMessage.error("请输入FBA订单发送时间！")
                                return false
                            }
                            if(isMeaningless(formDate.sendConditionFbaOrderDay)) {
                                this.$gjMessage.error("请输入FBM订单发送时间！")
                                return false
                            }
                        } else if(formDate.orderFulfillmentChannel === 'FBA'){
                            if(isMeaningless(formDate.sendConditionFbaOrderDay)) {
                                this.$gjMessage.error("请输入FBA订单发送时间！")
                                return false
                            }
                        } else if(formDate.orderFulfillmentChannel === 'FBM'){
                            if(isMeaningless(formDate.sendConditionFbaOrderDay)) {
                                this.$gjMessage.error("请输入FBM订单发送时间！")
                                return false
                            }
                        }
                    } else if(formDate.mailType !== 'HOLIDAYS_AUTO_REPLY') {
                        if(isMeaningless(formDate.sendConditionFbaOrderDay)) {
                            this.$gjMessage.error("请输入FBA订单发送时间！")
                            return false
                        }
                        if(isMeaningless(formDate.sendConditionFbaOrderDay)) {
                            this.$gjMessage.error("请输入FBM订单发送时间！")
                            return false
                        }
                    }
                    // 历史订单时间校验
                    if(formDate.mailType !== 'HOLIDAYS_AUTO_REPLY' && formDate.historicalOrder === 1 && isMeaningless(formDate.sendConditionFbaOrderDay)) {
                        this.$gjMessage.error("请输入历史订单兼容范围！")
                        return false
                    }
                    if(type === 'save' && this.$route.params.state == 'edit') {
                        countNotExecuteRecord({
                            marketIdList: formDate.countryMarketValue.marketIds,
                            ruleIdList: [this.id],
                            }).then(res => {
                            if(res[0].notExecuteCount > 0) {
                                const modal = this.$gjCreate('gj-info-modal', {
                                    props: {
                                        title: '温馨提示',
                                        content: `此规则已修改，历史规则有待发送任务：${res[0].notExecuteCount}条，如规则需要保存，则待发送任务自动失败。确认是否保存？`
                                    },
                                    on: {
                                        cancel: () => modal.$gjDestroy(),
                                        confirm: () => {
                                            callBack()
                                        }
                                    }
                                })
                            }else {
                                const modal = this.$gjCreate('gj-info-modal', {
                                    props: {
                                        title: '温馨提示',
                                        content: `此规则已修改，新任务按照新规则执行。确认是否保存？`
                                    },
                                    on: {
                                        cancel: () => modal.$gjDestroy(),
                                        confirm: () => {
                                            callBack()
                                        }
                                    }
                                })
                            }
                        })
                    } else {
                        callBack()
                    }
                } else {
                    this.$gjMessage.error("请先填写必填项！")
                    return false;
                }
            });
        },
        // 预览
        preview() {
            this.submitForm('preview',()=> {
                this.previewLoading = true
                let form = this.form
                let setTimeArr = []
                if(form.mailType === 'HOLIDAYS_AUTO_REPLY') {
                    this.setTime.forEach(item => {
                        setTimeArr.push({ startDate: convertToDate(item[0]), endDate: convertToDate(item[1]) })
                    })
                }
                let params = {
                    mailType: form.mailType,
                    name: form.name,
                    alreadyRepair: 'YES',
                    countryList: form.countryMarketValue.countryIds,
                    countrySelectType: form.countryMarketValue.countryIds.length > 0 ? 0 : 1,
                    marketIdList: form.countryMarketValue.marketIds,
                    marketSelectType: form.countryMarketValue.marketIds.length > 0 ? 0 : 1,
                    useCustomerTemplate: form.mailType !== 'AMAZON_REQUEST_REVIEW' ? form.useCustomerTemplate : 1,
                    useTemplateId: form.useCustomerTemplate === 0 ? this.form.templateInfo.ruleId : this.form.customInfo.ruleId,
                    templateInfo: form.useCustomerTemplate === 0 ? this.form.templateInfo : this.form.customInfo,
                    requestListingType: form.requestListingType,
                    requestListingList: form.requestListingType === 'AllListing' ? [] : this.goodsTableData.map(item => item.asin),
                    requestListingIdList: form.requestListingType === 'AllListing' ? [] : this.goodsTableData.map(item => item.id+''),
                    sendConditionHolidayUserInterval: 'ALL',
                    sendConditionHolidayDate: setTimeArr,
                    orderTypeSelect: form.orderTypeSelect,
                    orderTypeList: form.orderTypeSelect === 'ALL' ? [] : form.orderTypeList,
                    orderFulfillmentChannel: form.orderTypeSelect === 'ALL' ? '' : form.orderFulfillmentChannel,
                    filterOrder: form.orderTypeSelect === 'ALL' ? 'ALL' : form.filterOrder,
                    orderAmountSelect: form.orderTypeSelect === 'ALL' ? 'ALL' : form.orderAmountSelect,
                    orderAmountIntervalMin: ((form.orderTypeSelect === 'ALL' ? 'ALL' : form.orderAmountSelect) === 'ALL') ? '' : form.orderAmountIntervalMin,
                    orderAmountIntervalMax: ((form.orderTypeSelect === 'ALL' ? 'ALL' : form.orderAmountSelect) === 'ALL') ? '' : form.orderAmountIntervalMax,
                    orderAmountCurrency: this.currency,
                    filterSelect: form.filterSelect,
                    filterSendInterval: form.filterSelect === 'ALL' ? '' : form.filterSendInterval,
                    filterUserList: form.filterSelect === 'ALL' ? null : this.filterUserList,
                    sendConditionFbaOrderType: form.sendConditionFbaOrderType,
                    sendConditionFbaOrderDay: form.sendConditionFbaOrderDay,
                    sendConditionFbmOrderType: 'Purchase',
                    sendConditionFbmOrderDay: form.sendConditionFbmOrderDay,
                    sendConditionLocalTimeMin: form.sendConditionLocalTimeMin,
                    sendConditionLocalTimeMax: form.sendConditionLocalTimeMin + 1,
                    status: form.status,
                    sendConditionOldOrderRequestDay: form.historicalOrder === 1 ? form.sendConditionOldOrderRequestDay : 0
                }
                if(isMeaningful(params.templateInfo) && params.templateInfo.name === '') {
                    params.templateInfo.name = params.name + '_' + params.templateInfo.subject
                }
                if(form.mailType === 'AMAZON_REQUEST_REVIEW') {
                    params.useTemplateId = null
                    params.templateInfo = null
                }
                if (this.$route.params.state == 'edit') {
                    params.id = +this.$route.params.id
                }
                listOrderListView(params).then(res => {
                    this.$gjCreate(this.form.mailType == 'AMAZON_REQUEST_REVIEW' ? SendRulePreview : SendRulePreviewOther, {
                        props: {
                            dataList: res,
                            formDate: this._.cloneDeep(params)
                        }
                    })
                }).complete(() => this.previewLoading = false);
            })
        },
        save() {
            this.submitForm('save',()=> {
                let form = this.form
                this.loading = true;
                let setTimeArr = []
                if(form.mailType === 'HOLIDAYS_AUTO_REPLY') {
                    this.setTime.forEach(item => {
                        setTimeArr.push({ startDate: convertToDate(item.date[0]), endDate: convertToDate(item.date[1]) })
                    })
                }
                let params = {
                    mailType: form.mailType,
                    name: form.name,
                    alreadyRepair: 'YES',
                    countryList: form.countryMarketValue.countryIds,
                    countrySelectType: form.countryMarketValue.countryIds.length > 0 ? 0 : 1,
                    marketIdList: form.countryMarketValue.marketIds,
                    marketSelectType: form.countryMarketValue.marketIds.length > 0 ? 0 : 1,
                    useCustomerTemplate: form.mailType !== 'AMAZON_REQUEST_REVIEW' ? form.useCustomerTemplate : 1,
                    useTemplateId: form.useCustomerTemplate === 0 ? this.form.templateInfo.ruleId : this.form.customInfo.ruleId,
                    templateInfo: form.useCustomerTemplate === 0 ? this.form.templateInfo : this.form.customInfo,
                    requestListingType: form.requestListingType,
                    requestListingList: form.requestListingType === 'AllListing' ? [] : this.goodsTableData.map(item => item.asin),
                    requestListingIdList: form.requestListingType === 'AllListing' ? [] : this.goodsTableData.map(item => item.id+''),
                    sendConditionHolidayUserInterval: 'ALL',
                    sendConditionHolidayDate: setTimeArr,
                    orderTypeSelect: form.orderTypeSelect,
                    orderTypeList: form.orderTypeSelect === 'ALL' ? [] : form.orderTypeList,
                    orderFulfillmentChannel: form.orderTypeSelect === 'ALL' ? '' : form.orderFulfillmentChannel,
                    filterOrder: form.orderTypeSelect === 'ALL' ? 'ALL' : form.filterOrder,
                    orderAmountSelect: form.orderTypeSelect === 'ALL' ? 'ALL' : form.orderAmountSelect,
                    orderAmountIntervalMin: ((form.orderTypeSelect === 'ALL' ? 'ALL' : form.orderAmountSelect) === 'ALL') ? '' : form.orderAmountIntervalMin,
                    orderAmountIntervalMax: ((form.orderTypeSelect === 'ALL' ? 'ALL' : form.orderAmountSelect) === 'ALL') ? '' : form.orderAmountIntervalMax,
                    orderAmountCurrency: this.currency,
                    filterSelect: form.filterSelect,
                    filterSendInterval: form.filterSelect === 'ALL' ? '' : form.filterSendInterval,
                    filterUserList: form.filterSelect === 'ALL' ? null : this.filterUserList,
                    sendConditionFbaOrderType: form.sendConditionFbaOrderType,
                    sendConditionFbaOrderDay: form.sendConditionFbaOrderDay,
                    sendConditionFbmOrderType: 'Purchase',
                    sendConditionFbmOrderDay: form.sendConditionFbmOrderDay,
                    sendConditionLocalTimeMin: form.sendConditionLocalTimeMin,
                    sendConditionLocalTimeMax: form.sendConditionLocalTimeMin + 1,
                    status: form.status,
                    sendConditionOldOrderRequestDay: form.historicalOrder === 1 ? form.sendConditionOldOrderRequestDay : 0
                }
                if(isMeaningful(params.templateInfo) && params.templateInfo.name === '') {
                    params.templateInfo.name = params.name + '_' + params.templateInfo.subject
                }
                if(form.mailType === 'AMAZON_REQUEST_REVIEW') {
                    params.useTemplateId = null
                    params.templateInfo = null
                }
                if (this.$route.params.state == 'add') {
                    requestRuleAdd(params).then(res => {
                        if(res.resultCode === 'WARN') {
                            this.$gjMessage.warning(res.warnMsg);
                        } else if(res.resultCode === 'FAIL') {
                            this.$gjMessage.warning(res.errorMsg);
                        } else {
                            this.$gjMessage.success("新增成功");
                            this.close();
                        }
                    }).complete(() => this.loading = false);
                } else {
                    params.id = +this.$route.params.id
                    updateSendRule(params).then(res => {
                        if(res.resultCode === 'WARN') {
                            this.$gjMessage.warning(res.warnMsg);
                        } else if(res.resultCode === 'FAIL') {
                            this.$gjMessage.warning(res.errorMsg);
                        } else {
                            this.$gjMessage.success("编辑成功");
                            this.close();
                        }
                    }).complete(() => this.loading = false);
                }
            })
        },
        cancel() {
            const modal = this.$gjCreate('gj-info-modal', {
                props: {
                    title: "确认取消",
                    content: '一旦取消，将不会保存设置的规则，确认要取消吗？'
                },
                on: {
                    cancel: () => modal.$gjDestroy(),
                    confirm: () => {
                        this.close();
                    }
                }
            });
        },
        // 关闭新增编辑页面,清除缓存调整到关怀邮件列表页
        close() {
            const navTabIndex = this.navMenuTabs.findIndex(
                (e) => e.name === this.$route.meta.name
            );
            // tab页中肯定有dashboard
            if(navTabIndex > 0) {
                // 移除组件缓存
                const keepAliveIndex = this.keepAliveViews.findIndex(
                    (e) => e === this.navMenuTabs[navTabIndex].componentName
                );
                if (keepAliveIndex > -1) {
                    this.keepAliveViews.splice(keepAliveIndex, 1);
                }
                this.navMenuTabs.splice(navTabIndex, 1)
            }
            this.$router.push({path: '/crm/send-rule'})
        },
        // 滚动监听
        onBookmarkClick(item) {
            this.selectedId = item.id;
            let el = document.querySelector("#" + item.id)
            this.scrollToItem(el);
        },
        contentScroll(ev) {
            if (!this.enableListenScroll) {
            // 未启用滚动监听，直接跳过；防止scrollToItem自动滚动时，下面的监听逻辑重复运行
            return;
            }
            for (let item of this.timeLineArr) {
                const e = document.querySelector("#" + item.id);
                const itemRect = e.getBoundingClientRect();
                if (itemRect.top >= this.scrollRect.top || itemRect.bottom >= this.scrollRect.bottom) {
                    this.selectedId = item.id;
                    break;
                }
            }
        },
        outlineMouseEnter() {
            this.enableListenScroll = false;
        },
        contentMouseEnter() {
            this.enableListenScroll = true;
        },
        scrollToItem(anchorEle){
            if (anchorEle) {
            this.$refs.scrollRect.scrollTo({
                top: anchorEle.offsetTop - 93,
                left: 0,
                behavior: 'smooth'
            })
            }
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item {
    margin-bottom: 20px;
}
/deep/ .el-radio__label{
    color: #333333 !important;
  }
  .send-rule-add-main {
    height: 100%;
    display: flex;
    justify-content: space-between;

    .send-rule-left,
    .send-rule-right {
        box-sizing: border-box;
        padding: 15px;
    }

    .send-rule-left {
        width: 148px;
        height: 100%;
        background: #fff;
        margin-right: 12px;
        border-radius: 4px;
    }

    .send-rule-right {
        flex: 1;
        height: 100%;
        box-sizing: border-box;
        background: #fff;
        .send-rule-add {
            height: calc(100% - 102px);
            padding-right: 6%;
            box-sizing: border-box;
            position: relative;
            overflow-y: auto;
        }
        .send-rule-right-divider {
            background: #fff;
            padding-bottom: 15px;
            text-align: center;
        }

        .temlpate-mail-content {
            background: #F6F8FB;
            width: 100%;
            height: 358px;
            border: 1px solid #D8DADD;
            border-left: 0;

            .content-header {
                height: 30px;
                line-height: 30px;
                border-bottom: 1px solid #D8DADD;
                padding: 0 15px;

                .content-header-left {
                    float: left;
                }

                .content-header-right {
                    float: right;
                    color: #1F6EEF;
                    cursor: pointer;
                }
            }

            .content-text {
                padding: 12px 15px;
                overflow: auto;
                height: 320px;
                box-sizing: border-box;
            }
        }

        .editor-border {
            border-right: 0;
        }

        .currency {
            height: 32px;
            display: inline-block;
            background-color: #f5f7fa;
            color: #909399;
            vertical-align: middle;
            position: relative;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            padding: 0 15px;
            line-height: 30px;
            white-space: nowrap;
            box-sizing: border-box;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right: 0;
        }

        .tips {
            color: #1F6EEF;
            display: inline-block;
            cursor: pointer;
        }

        .el-input-group__prepend {
            padding: 0 10px;
        }

        .el-input-group__append {
            padding: 0 10px;
        }

        .send-rule-list {
            background: #F6F8FB;
            margin-top: 15px;
            padding: 16px 16px 1px 20px;
            box-sizing: border-box;
            width: 988px;
        }

        .el-icon-circle-plus-outline {
            margin-left: 10px;
        }

        .el-icon-circle-plus-outline,
        .el-icon-remove-outline {
            font-size: 20px;
            cursor: pointer;
            margin-right: 10px;
            vertical-align: middle;
        }
    }

    .market-time {
        .el-input__inner {
            padding-right: 20px;
        }
    }
}
</style>